import type { CSSProperties, FC } from 'react';
import { Spin } from 'antd';
import styles from './index.module.scss';

type SpinnerSize = 'small' | 'default' | 'large';

export interface LoadingSpinnerProps {
  size?: SpinnerSize;
  tip?: string | null;
  className?: string;
  style?: CSSProperties;
}

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 'default', tip = null, className = '', style }) => {
  const mergedClassName = [styles.container, className].filter(Boolean).join(' ');

  return (
    <div className={mergedClassName} style={style} aria-busy="true" aria-live="polite">
      <Spin size={size} tip={tip ?? undefined} />
    </div>
  );
};

export default LoadingSpinner;
